import React, { useEffect } from 'react';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Icon from 'components/Icon';
import useBindToContext from 'hooks/useBindToContext';

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<Icon icon="caret-down" />
		</components.DropdownIndicator>
	);
};

const colourStyles = (hasError, inInput) => ({
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			backgroundColor: isDisabled ? null : isSelected ? '#F5F9FC' : isFocused ? '#F5F9FC' : null,
			color: isDisabled ? '#ccc' : isSelected ? '#027FFF' : isFocused ? '#027FFF' : '#BEC3C5',
			cursor: isDisabled ? 'not-allowed' : 'default',
			fontSize: '0.875rem',
			textTransform: 'capitalize',
		};
	},
	control: (styles, { data, isDisabled, isFocused, isSelected, isHovered }) => {
		return {
			...styles,
			border: inInput ? 'none' : undefined,
			boxShadow: inInput ? 'none' : isFocused ? '0 0 0 3px rgba(66, 153, 225, 0.5)' : 'none',
			backgroundColor: inInput || isDisabled ? '#e2e8f0' : styles.backgroundColor,
			borderColor: inInput ? 'none' : hasError ? '#eb5757' : '#e2e8f0',
			borderRadius: inInput ? '4px 0 0 4px' : '4px',
			height: inInput ? '100%' : 39,
			minHeight: inInput ? '100%' : 39,
			fontWeight: inInput ? 'bold' : undefined,
			'&:hover': {
				borderColor: inInput ? 'none' : hasError ? '#eb5757' : '#e2e8f0',
			},
		};
	},
	singleValue: (styles, { data, isDisabled }) => ({
		...styles,
		fontSize: inInput ? 16 : 12,
		textTransform: 'capitalize',
		color: inInput ? '#4299e1' : isDisabled ? '#4a5568' : styles.color,
		fontSize: '0.875rem',
	}),
	dropdownIndicator: (styles, { isDisabled }) => ({
		...styles,
		color: inInput ? '#4299e1' : isDisabled ? '#4a5568' : styles.color,
		'&:hover': {
			color: inInput ? '#3182ce' : undefined,
		},
	}),
	indicatorSeparator: (styles) => ({ ...styles, display: inInput ? 'none' : 'initial' }),
	valueContainer: (styles) => ({ ...styles, padding: '0 8px 0 8px', height: '100%' }),
	menu: (styles) => ({ ...styles, padding: 0 }),
});

const Dropdown = (props) => {
	const {
		options = [],
		value,
		onChange,
		BindToContext = null,
		validation = true,
		getError = null,
		specificValidation = null,
		inInput = false,
		disabled,
		className = '',
		autoFocus = false,
		isMulti = false,
		closeMenuOnSelect=true,
		isCreatable = false
	} = props;
	const [BindedValue, BindedOnChange, hasError, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation
	);
	let selectedOption = !isMulti ?
		options.find((option) => option.value == BindedValue)
			:
		options.filter((option) => BindedValue.indexOf(option.value) !== -1);

	const handleChange = (option) => {
		if(!option){
			BindedOnChange(isMulti ? [] : null)
		}else  if(Array.isArray(option)){
			BindedOnChange(option.map(op => op.value))
		}else {
			BindedOnChange(option.value)
		}
	}
	//useEffect(() => {
		//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	if(isCreatable){
		let createdOptions = !BindedValue ?
		[]
			:
		BindedValue.map(v => ({ value: v, label: v }))
		return (
			<CreatableSelect
				isClearable={false}
				{...props}
				className={`basic-single ${className}`}
				classNamePrefix="select"
				isClearable={false}
				isDisabled={disabled}
				value={createdOptions}
				onChange={handleChange}
				components={{ DropdownIndicator, indicatorSeparator: null }}
				styles={colourStyles(hasError, inInput)}
				autoFocus={autoFocus}
				isMulti={isMulti}
				// menuIsOpen={false}
				closeMenuOnSelect={closeMenuOnSelect}
			/>
		)
	} else
		return (
			<Select
				{...props}
				className={`basic-single ${className}`}
				classNamePrefix="select"
				isClearable={false}
				isDisabled={disabled}
				value={selectedOption}
				onChange={handleChange}
				components={{ DropdownIndicator, indicatorSeparator: null }}
				styles={colourStyles(hasError, inInput)}
				autoFocus={autoFocus}
				isMulti={isMulti}
				closeMenuOnSelect={closeMenuOnSelect}
			/>
		)
};

export default Dropdown;
